import useEditShopContext from 'contexts/shop.context';
import React from 'react';

const PreviewShopMetadata = () => {
  const { shopDetails } = useEditShopContext();

  return (
    <div className='space-y-6'>
      <div className='w-full flex gap-[30px] border border-[#EAEBEB] px-[24px] py-[20px] rounded-xl my-6  justify-start'>
        <div className='w-[150px]'>
          <p className='text-[#858585] text-sm font-medium'>Keywords</p>
        </div>

        <div className='flex gap-[12px] flex-wrap'>
          {shopDetails?.brand_keywords?.map((item, index) => (
            <div
              key={index}
              className='bg-[#FEF0F2] flex gap-[5px] items-center rounded-[20px] px-[12px] pt-[2px] pb-[3px]'>
              <p className='text-[#E60A2B] text-sm'>{item.name}</p>
            </div>
          ))}
        </div>
      </div>
      <div className='w-full flex gap-[30px] border border-[#EAEBEB] px-[24px] py-[20px] rounded-xl my-6  justify-start'>
        <div className='w-[150px]'>
          <p className='text-[#858585] text-sm font-medium'>Descriptive Metadata</p>
        </div>

        <div className='flex gap-[12px] flex-wrap'>
          {shopDetails?.brand_descriptive_metadatas?.map((item, index) => (
            <div
              key={index}
              className='bg-[#FEF0F2] flex gap-[5px] items-center rounded-[20px] px-[12px] pt-[2px] pb-[3px]'>
              <p className='text-[#E60A2B] text-sm'>{item.name}</p>
            </div>
          ))}
        </div>
      </div>
      <div className='w-full flex gap-[30px] border border-[#EAEBEB] px-[24px] py-[20px] rounded-xl my-6  justify-start'>
        <div className='w-[150px]'>
          <p className='text-[#858585] text-sm font-medium'>Business Metadata</p>
        </div>

        <div className='flex gap-[12px] flex-wrap'>
          {shopDetails?.brand_business_metadatas?.map((item, index) => (
            <div
              key={index}
              className='bg-[#FEF0F2] flex gap-[5px] items-center rounded-[20px] px-[12px] pt-[2px] pb-[3px]'>
              <p className='text-[#E60A2B] text-sm'>{item.name}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PreviewShopMetadata;
